import { useLayoutEffect } from 'react';

import { Outlet } from 'react-router-dom';

import { useTopbarStore } from '@/components/topbar/topbar-store';

import { TopbarActions } from './topbar-actions';

function LocationsLayout() {
  useLayoutEffect(() => {
    useTopbarStore.getState().setActions(<TopbarActions />);

    return () => {
      useTopbarStore.getState().setActions(<></>);
    };
  }, []);

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}

export default LocationsLayout;
